import React from "react";

type Props = {
  width: number;
  height: number;
};

export const LoginSVG: React.FC<Props> = (props) => {
  const { width, height } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 54 54`}
    >
      <g
        id="Buttons_-_Symbol"
        data-name="Buttons - Symbol"
        transform="translate(-0.196)"
      >
        <rect
          id="Frame"
          width="54"
          height="54"
          transform="translate(0.196)"
          fill="#fff"
          opacity="0"
        />
        <g
          id="レイヤー_2"
          data-name="レイヤー 2"
          transform="translate(4.684 5.262)"
        >
          <g id="icons">
            <g
              id="レイヤー_2-2"
              data-name="レイヤー 2"
              transform="translate(3.4 0)"
            >
              <g id="icons-2" data-name="icons" transform="translate(4 3.69)">
                <path
                  id="パス_26969"
                  data-name="パス 26969"
                  d="M14.829,0C6.51.155,0,7.292,0,15.612V33.95a2.146,2.146,0,0,0,4.152.764c.836-2.214,1.764-4.173,3.408-4.173,3.78,0,3.78,5.328,7.56,5.328s3.777-5.328,7.555-5.328c1.636,0,2.563,1.949,3.4,4.157a2.146,2.146,0,0,0,4.152-.763V15.111A15.111,15.111,0,0,0,14.829,0ZM12.993,15.742,8.886,19.971a.233.233,0,0,1-.388-.236l.86-2.581a.233.233,0,0,0-.221-.307H7.163a.233.233,0,0,1-.215-.322l1.774-4.3a.233.233,0,0,1,.215-.144h2.687a.233.233,0,0,1,.2.351L10.321,15a.233.233,0,0,0,.2.351h2.3a.233.233,0,0,1,.167.4Zm10.234,0L19.12,19.971a.233.233,0,0,1-.388-.236l.86-2.581a.233.233,0,0,0-.221-.307H17.4a.233.233,0,0,1-.215-.322l1.774-4.3a.233.233,0,0,1,.215-.144h2.687a.233.233,0,0,1,.2.351L20.556,15a.233.233,0,0,0,.2.351h2.3a.233.233,0,0,1,.167.4Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
